import { makeContextModule } from '@cian/react-utils';

import { IApplicationContext } from '../../types/applicationContext';

export const { Context: ApplicationContext, useContext: useApplicationContext } =
  makeContextModule<IApplicationContext>({
    contextName: 'ApplicationContext',
  });
